import { Injectable } from '@angular/core';
import packageJson from '../../../../../package.json';

/**
 * Servicio para gestionar la información de versión de la aplicación.
 * La versión se sincroniza automáticamente con package.json durante el build.
 */
@Injectable({
  providedIn: 'root',
})
export class VersionService {
  /**
   * Versión actual de la aplicación desde package.json
   */
  readonly version: string = packageJson.version;

  /**
   * Nombre de la aplicación desde package.json
   */
  readonly appName: string = packageJson.name;

  /**
   * Obtiene la versión formateada para mostrar
   */
  getFormattedVersion(): string {
    return `v${this.version}`;
  }

  /**
   * Determina el tipo de ambiente basado en la versión
   */
  getEnvironmentType(): 'dev' | 'staging' | 'production' {
    if (this.version.includes('-dev')) return 'dev';
    if (this.version.includes('-rc')) return 'staging';
    return 'production';
  }
}
